import { vars } from '@repo/config';
import { fetchGetWithRetry } from './helper';

interface ISessionResponse {
  session?: { user?: unknown } | null;
  user?: unknown;
}

export async function checkSession(cookieHeader: string): Promise<boolean> {
  if (!cookieHeader) {
    return false;
  }

  const sessionUrl = new URL('/api/auth/get-session', vars.url.identityUrl).toString();

  try {
    const response = await fetchGetWithRetry(sessionUrl, cookieHeader);
    if (!response.ok) {
      return false;
    }
    const data = (await response.json()) as ISessionResponse;
    return data.session != null && data.user != null;
  } catch {
    return false;
  }
}
